export const I18N_NAMESPACES_REMOTE_CONFIG_KEY = "i18n_namespaces_v1";

const REMOTE_CONFIG_KEY_PATTERN = /^i18n_[a-z0-9_]+_v\d+$/;

export function readDynamicRemoteConfigKeys(
  rawValue: string,
  builtInKeys: readonly string[] = [],
): string[] {
  if (!rawValue.trim()) return [];

  try {
    const parsed = JSON.parse(rawValue) as
      | string[]
      | {
          keys?: unknown;
          namespaces?: unknown;
        };
    const values = Array.isArray(parsed)
      ? parsed
      : Array.isArray(parsed.keys)
        ? parsed.keys
        : Array.isArray(parsed.namespaces)
          ? parsed.namespaces
          : [];
    const blockedKeys = new Set<string>([
      ...builtInKeys,
      I18N_NAMESPACES_REMOTE_CONFIG_KEY,
    ]);

    return values
      .filter((value): value is string => typeof value === "string")
      .map((value) => value.trim())
      .filter((value) => REMOTE_CONFIG_KEY_PATTERN.test(value))
      .filter((value) => !blockedKeys.has(value))
      .filter((value, index, list) => list.indexOf(value) === index)
      .slice(0, 25);
  } catch {
    return [];
  }
}
